import {
  Text,
  BorderRadius6,
  GreyGrey10,
  GreyGrey20,
  GreyGrey60,
  GreyGrey70,
  GreyGrey80,
  IconComponent,
  ListItem,
  Primary13SemiBold,
  Primary13Regular,
  Primary24SemiBold,
  UnorderedList,
  Box,
  Flex,
  Grid
} from '@sequencehq/core-components'
import { FC } from 'react'

export const SimplePaymentPage: FC<{
  icon: IconComponent
  iconColour: string
  header: string
  subheader: string
  nextSteps: string[]
}> = ({ icon, iconColour, header, subheader, nextSteps }) => {
  const IconComponent = icon

  return (
    <Flex
      alignItems="center"
      flexDir="column"
      minH="100svh"
      pb="3rem"
      justifyContent="center"
      margin="auto"
      width="380px"
      maxW="calc(100% - 32px)"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        textAlign="center"
      >
        <Grid
          width="36px"
          height="36px"
          marginBottom="16px"
          backgroundColor={GreyGrey20}
          borderRadius={BorderRadius6}
          justifyContent="center"
          alignContent="center"
        >
          <IconComponent size={24} color={iconColour} />
        </Grid>

        <Text {...Primary24SemiBold} marginBottom="8px" color={GreyGrey80}>
          {header}
        </Text>

        <Text {...Primary13Regular} color={GreyGrey60}>
          {subheader}
        </Text>
      </Flex>
      <Box height="36px" />
      <Flex
        justifyContent="center"
        flexDirection="column"
        backgroundColor={GreyGrey10}
        padding="16px"
        rounded={BorderRadius6}
      >
        <Text {...Primary13SemiBold} color={GreyGrey70} marginBottom="8px">
          What's next:
        </Text>

        {nextSteps.length > 1 ? (
          <UnorderedList>
            {nextSteps.map((step, index) => (
              <ListItem key={index}>
                <Text {...Primary13Regular} color={GreyGrey70}>
                  {step}
                </Text>
              </ListItem>
            ))}
          </UnorderedList>
        ) : (
          <Text {...Primary13Regular} color={GreyGrey70}>
            {nextSteps[0]}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
